import {TrainerEmulationContainer} from '@/components/TrainerEmulationContainer/TrainerEmulationContainer';
import {Outlet} from 'react-router-dom';
import AuthContainer from '../components/AuthContainer/AuthContainer';
import WithCurrentProfileContainer from '../components/WithCurrentProfileContainer/WithCurrentProfileContainer';
import {UserProvider} from '../context/UserContextProvider';

export default function RootAuthenticatedLayout() {
  return (
    <AuthContainer>
      <UserProvider>
        <TrainerEmulationContainer>
          <WithCurrentProfileContainer>
            <Outlet />
            {/* <TourDisplay>
            </TourDisplay> */}
          </WithCurrentProfileContainer>
        </TrainerEmulationContainer>
      </UserProvider>
    </AuthContainer>
  );
}
